import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AdminPitchMessages from "../components/AdminPitchMessages";
import * as actions from "../../../../../actions/project.actions";
import * as adminActions from "../../../../../actions/admin.actions";
import * as commonActions from "../../../../../actions/common.actions";
import * as projectActions from "../../../../../actions/project.actions";
import hireModal from "../../../../employer/memberProfile/components/hireModal";

const approvedSubHeader = (projectId, totalMatches, totalPitches) => {
  return {
    items: [
      {
        caption: "Project Detail",
        url: `/admin/project/${projectId}/detail`
      },
      {
        caption: `Matches (${totalMatches})`,
        url: `/admin/project/${projectId}/matches`
      },
      {
        caption: `Pitches (${totalPitches})`,
        url: `/admin/project/${projectId}/pitches`
      },
      {
        caption: "SOW",
        url: `/admin/project/${projectId}/sow`
      },
      {
        caption: "Reviews",
        url: `/admin/project/${projectId}/reviews`
      }
    ],
    activeItem: null
  };
};

const pitchPending = (hireMember, declineMember) => ({
  color: "blue",
  title: "This Member Has Pitched Your Project",
  text: (
    <span>
      Click Hire to decline all other member pitches and move this member to the
      Statement of Work phase.
    </span>
  ),
  buttons: [
    {
      text: "Decline",
      onClick: declineMember
    },
    {
      text: "Hire",
      type: "modalTrigger",
      color: "blue",
      modal: hireModal,
      modalClick: hireMember
    }
  ]
});
class AdminPitchMessagesContainer extends Component {
  constructor(props) {
    super(props);

    this.declineMember = this.declineMember.bind(this);
    this.hireMember = this.hireMember.bind(this);
  }

  componentDidMount() {
    const pitchId = this.props.match.params.pitchId;
    this.props.actions.getMessagesByPitchId(pitchId);
    this.props.projectActions.getPitch(pitchId);
    this.props.adminActions.getProject(this.props.match.params.projectId);
  }

  componentWillUnmount() {
    this.props.commonActions.setHeaderBar({});
    this.props.commonActions.setSubHeader({});
  }

  componentDidUpdate(prevProps) {
    if (this.props != prevProps) {
      this.setHeaderBar(prevProps);
      this.setSubHeader(prevProps);
    }
  }

  setHeaderBar(prevProps) {
    const pitch = this.props.pitch;

    let headerBar = pitchPending(this.hireMember, this.declineMember);

    if (pitch != prevProps.pitch) {
      this.props.commonActions.setHeaderBar(headerBar);
    }
  }

  setSubHeader(prevProps) {
    const project = this.props.project;
    const status = _.get(this.props.project, "status.name");

    const totalMatches = _.get(project, "stats.matches.matched");
    const totalPitches =
      _.get(project, "stats.pitches.accepted") +
      _.get(project, "stats.pitches.pending");

    let subHeader = {};

    if (status !== undefined && project !== prevProps.project) {
      subHeader = approvedSubHeader(project.id, totalMatches, totalPitches);
      this.props.commonActions.setSubHeader(subHeader);
    }
  }

  hireMember() {
    const payload = {
      pitch_id: this.props.pitch.id,
      accept: true
    };
    this.props.projectActions.acceptPitch(payload, this.props.project.id);
  }

  declineMember() {
    const payload = {
      pitch_id: this.props.pitch.id,
      accept: false
    };
    this.props.projectActions.acceptPitch(payload, this.props.project.id);
  }

  render() {
    return (
      <AdminPitchMessages
        messages={this.props.messages}
        project={this.props.project}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    project: state.admin.project,
    pitch: state.project.pitch,
    member: state.project.member,
    messages: state.project.messages
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch),
    adminActions: bindActionCreators(adminActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    projectActions: bindActionCreators(projectActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminPitchMessagesContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/project/messages/containers/AdminPitchMessagesContainer.js